import {Pipe, PipeTransform} from '@angular/core';
import {AceLogger} from '@app/logging/ace-logger';
import {AceLoggerService} from '@app/logging/ace-logger.service';
import {DAY_MS} from '../util/general/duration-utils';

export type MsDenomination = 'days';
const denominations: Set<MsDenomination> = new Set(['days']);

@Pipe({name: 'convertMs', standalone: false})
export class ConvertMsPipe implements PipeTransform {
  private readonly logger: AceLogger;

  constructor(loggerService: AceLoggerService) {
    this.logger = loggerService.create(ConvertMsPipe.name);
  }

  transform(value: number, denomination?: MsDenomination): number;
  transform(value: number, denomination: MsDenomination = 'days'): number {
    if (denominations.has(denomination)) {
      return ConvertMsPipe.convertMs(value, denomination);
    } else {
      this.logger.error('Invalid denomination of milliseconds: ', denomination);
      return value;
    }
  }

  static convertMs(ms: number, denomination: MsDenomination = 'days'): number {
    if (ms != null) {
      if (denomination === 'days') {
        return ms / DAY_MS;
      }
    }
    return ms;
  }
}
